
import {Component, Mixins, Prop, Ref, Watch} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import BelgeTuruPicker from "@/components/pickers/BelgeTuruPicker.vue";
import TebligatAdresTuruPicker from "@/components/pickers/TebligatAdresTuruPicker.vue";
import AdresSelectableList from "@/components/lists/AdresSelectableList.vue";
import TebligatTeslipTipiPicker from "@/components/pickers/TebligatTeslipTipiPicker.vue";
import TakipTipiPicker from "@/components/pickers/TakipTipiPicker.vue";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";
import Dates from "@/components/inputs/Dates.vue";
import {TebligatSekli, TebligatSekliLabel} from "@/enum/TebligatSekli";
import {TebligatDurumu, TebligatDurumuLabel} from "@/enum/TebligatDurumu";
import {TebligatAdresTuru} from "@/enum/TebligatAdresTuru";
import {TebligatEntity} from "@/entity/TebligatEntity";
import {BorcluEntity} from "@/entity/BorcluEntity";
import {AdresEntity} from "@/entity/AdresEntity";
import {TakipTalebiEntity} from "@/entity/TakipTalebiEntity";
import {TakipTipiEntity} from "@/entity/TakipTipiEntity";
import {IlamliTebligatBelgeTuru, IlamsizTebligatBelgeTuru} from "@/enum/TebligatBelgeTuru";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import ItirazinIptaliDavasiInfo from "@/components/infos/ItirazinIptaliDavasiInfo.vue";
import {TakipYoluLabel, TakipTipi} from "@/enum/TakipTipi";
import {TakipDurumu} from "@/enum/TakipDurumu";
import {TebligatTuru, TebligatTuruLabel} from "@/enum/TebligatTuru";
import type {PttSonDurum, PttBarkodResponse, PttHareket, PttBarkodSorgulaCevap} from "@/plugins/uyap-plugin/uyap/PttBarkodSorgula";
import TebligatTuruPicker from "@/components/pickers/TebligatTuruPicker.vue";
import TebligatSekliPicker from "@/components/pickers/TebligatSekliPicker.vue";
import TebligatDurumuPicker from "@/components/pickers/TebligatDurumuPicker.vue";

@Component({
  components: {
    TebligatDurumuPicker,
    TebligatSekliPicker,
    TebligatTuruPicker,
    ItirazinIptaliDavasiInfo,
    FormDialog,
    FormWrapper,
    TakipTipiPicker,
    BelgeTuruPicker,
    TebligatAdresTuruPicker,
    AdresSelectableList,
    TebligatTeslipTipiPicker,
    EnabledSwitch,
    Dates
  }
})
export default class TebligatForm extends Mixins(ObjectInputMixin) {
  @Prop({}) borclu!: any;
  @Prop({}) successOnValidate !: any;
  @Ref('formWrapper') formWrapper!: FormWrapper;
  @Prop({}) adres!: any
  @Prop({}) takipTipi!: any

  tebligatAdresTuru = TebligatAdresTuru;
  TebligatDurumu = TebligatDurumu;
  localValue: any = new TebligatEntity();
  adresLength: boolean = false
  TakipYoluLabel = TakipYoluLabel;
  takipDurumu = TakipDurumu;
  warning = false;
  barkodSonuclari: any[] = [];
  barkodLoading: boolean = false;
  sonDurumMetni: string = "";
  sonDurumBilgisi: PttSonDurum | null = null;
  barkodHamVeri: PttBarkodResponse | null = null;
  showBarkodDetay: boolean = false;


  get isSuccessOnValidate() {
    return this.successOnValidate || this.successOnValidate === "";
  }

  get action() {
    if (this.isSuccessOnValidate) {
      return null;
    }
    return "/api/v1/tebligat";
  }

  get adresEkleAction() {
    if (this.borclu.kisi) {
      return '/api/v1/kisi/' + this.borclu.kisi_id + '/adres';
    } else if (this.borclu.kurum) {
      return '/api/v1/kurum/' + this.borclu.kurum_id + '/adres';
    }
    return null;
  }

  /*get takipTipleri(): Array<TakipTipiEntity> {
    return this.borclu.takip.talepler.map((takipTalebi: TakipTalebiEntity) => {
      return takipTalebi.takip_tipi;
    });
  }
*/
  get ilamli() {
    // takipTipi'nin varlığını kontrol et
    if (this.takipTipi && this.takipTipi.ilamli !== undefined) {
      return this.takipTipi.ilamli === 1; // 0/1 değerini boolean'a çevir
    }
    return false;
  }

  get minTebligatGonderimTarihi() {
    if (this.borclu.takip.takip_durumu == this.takipDurumu.acik && this.borclu.takip.takip_tarihi)
      return this.borclu.takip.takip_tarihi;
    return;
  }

  @Watch("localValue.tebligat_durumu")
  onTebligatDurumuValueChange() {
    this.clearTebligatForm();
  }

  @Watch("localValue.teblig_tarihi")
  onPropertyChanged(value: string, oldValue: string) {
    let sonOdemeSuresi = this.localValue.takip_tipi?.odeme_suresi;
    if (this.localValue.teblig_tarihi) {
      let sonOdemeTarihi = new Date(this.localValue.teblig_tarihi);
      sonOdemeTarihi.setDate(sonOdemeTarihi.getDate() + sonOdemeSuresi);
      this.localValue.son_odeme_tarihi = sonOdemeTarihi;
    }
    this.tebligTarihiniIzleyenGun;
  }

  @Watch('localValue.son_odeme_tarihi')
  onSonOdemeTarihiChange() {
    if (!this.localValue.son_odeme_tarihi) {
      this.tebligTarihiniIzleyenGun
    }
  }

  onItirazVarMiChange() {
    if (this.localValue.itiraz_var_mi) {
      delete this.localValue.kesinlesme_tarihi;
      delete this.localValue.son_odeme_tarihi;
    } else {
      delete this.localValue.itiraz_nedeni;
      delete this.localValue.itiraz_tarihi;
      delete this.localValue.itiraz_teblig_tarihi;
    }
    this.input();
  }

  async barkodSorgulama() {
    if (!this.localValue.barkod_no) {
      this.$toast.warning("Lütfen önce barkod numarası giriniz.");
      return;
    }

    try {
      this.barkodLoading = true;
      this.formWrapper.onFly = true;

      console.log("DevMode:", this.$store.getters.isEicraproDevMode);
      console.log("Barkod No:", this.localValue.barkod_no);

      if(!this.$socket.connected){
        this.$toast.error("Zirve Bilgisayar imza gereci açık değil. Lütfen imza programını açınız.");
        return;
      }

      const result = await this.$uyap.PttBarkodSorgula().run([this.localValue.barkod_no]);
      console.log("PTT Barkod Sonucu:", result);

      if (result.status === 'error') {
        this.$toast.error(result.message || "Barkod sorgulanamadı");
        this.barkodSonuclari = [];
        this.sonDurumMetni = "";
        this.sonDurumBilgisi = null;
        this.barkodHamVeri = null;
        return;
      }

      // PTT kargo takip bilgilerini tabloda göster
      this.barkodSonuclari = result.items || [];
      this.showBarkodDetay = false;
      this.sonDurumMetni = result.updateData?.son_durum || result.message || "";
      this.sonDurumBilgisi = result.rawData?.sondurum || null;
      this.barkodHamVeri = result.rawData || null;
      this.formuBarkodSonucuIleDoldur(result);

      if (this.barkodSonuclari.length > 0) {
        this.$toast.success("PTT kargo takip bilgileri başarıyla yüklendi");
      } else {
        this.$toast.info("Barkod sorgulandı ancak hareket bilgisi bulunamadı");
      }
    } catch (error) {
      this.$toast.error("Barkod sorgulanırken hata oluştu: " + (error instanceof Error ? error.message : "Bilinmeyen hata"));
      console.error("Barkod sorgulama hatası:", error);
      this.barkodSonuclari = [];
      this.sonDurumMetni = "";
      this.showBarkodDetay = false;
      this.sonDurumBilgisi = null;
      this.barkodHamVeri = null;
    } finally {
      this.barkodLoading = false;
      this.formWrapper.onFly = false;
    }
  }

  formuBarkodSonucuIleDoldur(result: PttBarkodSorgulaCevap) {
    const updateData = result.updateData || ({} as PttBarkodSorgulaCevap["updateData"]);

    if (!this.localValue.tebligat_turu) {
      this.localValue.tebligat_turu = this.barkoddanTebligatTuruBul(result);
    }

    const gonderimTarihi = this.parsePttDate(updateData.tebligat_gonderim_tarihi);
    if (gonderimTarihi) {
      this.localValue.tebligat_gonderim_tarihi = gonderimTarihi;
    }

    const tebligatDurumu = this.barkoddanTebligatDurumuBul(result);
    if (tebligatDurumu) {
      this.localValue.tebligat_durumu = tebligatDurumu;
    }

    if (this.localValue.tebligat_durumu === TebligatDurumu.bila_oldu) {
      this.localValue.bila_sebebi = updateData.bila_sebebi || this.localValue.bila_sebebi;
      this.localValue.bila_tarihi = this.parsePttDate(updateData.bila_tarihi) || this.localValue.bila_tarihi;
    }

    if (this.localValue.tebligat_durumu === TebligatDurumu.teblig_edildi) {
      const tebligTarihi = this.parsePttDate(updateData.teslim_tarihi);
      if (tebligTarihi) {
        this.localValue.teblig_tarihi = tebligTarihi;
      }
    }

    this.input();
  }

  barkoddanTebligatTuruBul(result: PttBarkodSorgulaCevap): TebligatTuru {
    const ekHizmetler = result.rawData?.kabul?.ekhizmetler?.toUpperCase() || "";
    if (ekHizmetler.includes("HIZLI") || ekHizmetler.includes("APS")) {
      return TebligatTuru.hizli;
    }
    return TebligatTuru.normal;
  }

  barkoddanTebligatDurumuBul(result: PttBarkodSorgulaCevap) {
    const updateDurum = result.updateData?.tebligat_durumu;
    if (updateDurum === "teslim_edildi") {
      return TebligatDurumu.teblig_edildi;
    }
    if (updateDurum === "bila") {
      return TebligatDurumu.bila_oldu;
    }

    const sonDurum = `${result.son_durum || ""} ${result.message || ""}`.toUpperCase();
    if (sonDurum.includes("TESLİM") || sonDurum.includes("TESLIM")) {
      return TebligatDurumu.teblig_edildi;
    }
    if (sonDurum.includes("İADE") || sonDurum.includes("IADE") || sonDurum.includes("BILA")) {
      return TebligatDurumu.bila_oldu;
    }
    return TebligatDurumu.gonderildi;
  }

  parsePttDate(value: string | null | undefined): Date | null {
    if (!value) {
      return null;
    }

    const normalized = value.trim();
    const slashMatch = normalized.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (slashMatch) {
      const [, gun, ay, yil] = slashMatch;
      return new Date(Number(yil), Number(ay) - 1, Number(gun));
    }

    const isoMatch = normalized.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (isoMatch) {
      const [, yil, ay, gun] = isoMatch;
      return new Date(Number(yil), Number(ay) - 1, Number(gun));
    }

    const intMatch = normalized.replace(/[^0-9]/g, "");
    if (intMatch.length === 8) {
      const yil = intMatch.substring(0, 4);
      const ay = intMatch.substring(4, 6);
      const gun = intMatch.substring(6, 8);
      return new Date(Number(yil), Number(ay) - 1, Number(gun));
    }

    return null;
  }

  clearTebligatForm() {
    if (this.localValue.tebligat_durumu == TebligatDurumu.gonderildi) {
      this.localValue.teblig_tarihi = null;
      this.localValue.kesinlesme_tarihi = null;
      this.localValue.son_odeme_tarihi = null;
      this.localValue.tebligat_teslim_tipi_id = undefined;
      this.localValue.teslim_alan = undefined;
      this.localValue.bila_sebebi = undefined;
      this.localValue.bila_tarihi = null;
      this.localValue.itiraz_var_mi = false;
      this.localValue.itiraz_teblig_tarihi = null;
      this.localValue.mal_beyaninda_bulundu_mu = false;
    } else if (this.localValue.tebligat_durumu == TebligatDurumu.teblig_edildi) {
      this.localValue.bila_sebebi = undefined;
      this.localValue.bila_tarihi = null;
    } else if (this.localValue.tebligat_durumu == TebligatDurumu.bila_oldu) {
      this.localValue.teblig_tarihi = undefined;
      this.localValue.kesinlesme_tarihi = null;
      this.localValue.son_odeme_tarihi = null;
      this.localValue.tebligat_teslim_tipi_id = undefined;
      this.localValue.teslim_alan = undefined;
      this.localValue.itiraz_var_mi = false;
      this.localValue.itiraz_teblig_tarihi = null;
      this.localValue.mal_beyaninda_bulundu_mu = false;
    }
  }

  setDefaultValues() {
    if (!this.localValue.adres) {
      if (this.borclu?.kisi) {
        this.localValue.adres = <AdresEntity>{...this.borclu.kisi.varsayilan_adres};
      } else if (this.borclu?.kurum) {
        this.localValue.adres = <AdresEntity>{...this.borclu.kurum.varsayilan_adres};
      }
    }
    this.localValue.borclu_id = this.borclu.id;

    if (!this.localValue.tebligat_adres_turu) {
      this.localValue.tebligat_adres_turu = TebligatAdresTuru.yeniadres;
    }

    if (!this.localValue.tebligat_sekli) {
      this.localValue.tebligat_sekli = TebligatSekli.normal;
    }

    if (!this.localValue.itiraz_var_mi) {
      this.localValue.itiraz_var_mi = false;
    }
    if (!this.localValue.mal_beyaninda_bulundu_mu) {
      this.localValue.mal_beyaninda_bulundu_mu = false;
    }
    if (this.localValue?.takip_tipi) {

      if (this.ilamli && this.localValue.belge_turu == IlamsizTebligatBelgeTuru.odemeemri) {
        this.localValue.belge_turu = IlamliTebligatBelgeTuru.icraemri;
      } else if (this.localValue.belge_turu == IlamliTebligatBelgeTuru.icraemri) {
        this.localValue.belge_turu = IlamsizTebligatBelgeTuru.odemeemri;
      }
    }
    if (this.takipTipi && !this.localValue.takip_tipi) {
      this.localValue.takip_tipi = Array.isArray(this.takipTipi) ? this.takipTipi[0] : this.takipTipi;
      this.localValue.takip_tipi_id = this.localValue.takip_tipi?.id;
    }
    if (!this.localValue.itirazin_iptali_davasi) {
      this.localValue.itirazin_iptali_davasi = [];
    }
    this.input();
  }

  onTakipTipiChange() {
    if (this.localValue.takip_tipi?.id) {
      this.localValue.takip_tipi_id = this.localValue.takip_tipi.id;
    }
    this.setDefaultValues();
  }

  get itirazVarMi() {
    // Önce takip_tipi'nin varlığını kontrol et
    if (!this.localValue.takip_tipi?.aciklama) {
      return true; // varsayılan olarak itiraz var kabul et
    }

    return !(this.localValue.takip_tipi.aciklama === TakipYoluLabel.cocukTeslimi ||
        this.localValue.takip_tipi.aciklama === TakipYoluLabel.menkulTeslimi ||
        this.localValue.takip_tipi.aciklama === TakipYoluLabel.paraBorcuVeyaTeminat ||
        this.localValue.takip_tipi.aciklama === TakipYoluLabel.ipotekIcraEmri ||
        this.localValue.takip_tipi.aciklama === TakipYoluLabel.tasinirRehni);
  }

  get itirazinIptaliDavasiGoster() {
    // İtiraz aktif değilse gösterme
    if (!this.localValue.itiraz_var_mi) {
      return false;
    }
    
    const takipTipiId = this.localValue.takip_tipi?.id;
    if (takipTipiId == null) return false;

    return [
      TakipTipi.ilamsiz,
      TakipTipi.menkulRehni,
      TakipTipi.adiKira,
      TakipTipi.cocukTeslimi,
      TakipTipi.ipotekIcraEmri,
      TakipTipi.iflas
    ].includes(takipTipiId);
  }

  get sonOdemeTarihiLabel() {
    let label = "";
    switch (this.localValue.takip_tipi?.aciklama) {
      case TakipYoluLabel.cocukTeslimi: {
        label = "Çocuğun Teslim Edildiği Tarih";
        break;
      }
      case TakipYoluLabel.menkulTeslimi: {
        label = "Tahliye/Teslim/İşin Yapılması Tarihi";
        break;
      }
      case TakipYoluLabel.tahliye: {
        label = "Tahliye Tarihi";
        break;
      }
      default:
        label = "Son Ödeme Tarihi";
        break;
    }
    return label;
  }

  get tebligTarihiniIzleyenGun() {
    let warningMessage = "";
    // takip_tipi ve odeme_suresi kontrolü ekle
    if (this.localValue.teblig_tarihi && this.localValue.takip_tipi?.odeme_suresi) {
      let fark = this.$helper.tarihFarkiGunSayisi(new Date(), new Date(this.localValue.teblig_tarihi));
      if (Math.abs(fark) >= this.localValue.takip_tipi.odeme_suresi && !this.localValue.son_odeme_tarihi) {
        warningMessage = "Tebliğ tarihi üzerinden " + Math.abs(fark) + " gün geçti.";
        this.warning = true;
      } else {
        this.warning = false;
      }
    }
    return warningMessage;
  }

  get sonDurumRenk() {
    const durum = this.sonDurumMetni?.toUpperCase();
    if (durum?.includes('TESLİM') || durum?.includes('TESLIM')) {
      return 'success';
    } else if (durum?.includes('İADE') || durum?.includes('IADE')) {
      return 'error';
    } else if (durum?.includes('DAĞITIM') || durum?.includes('DAGITIM')) {
      return 'warning';
    } else {
      return 'info';
    }
  }

  get sonDurumEtiketi() {
    return this.sonDurumMetni?.trim() || 'Durum yok';
  }

  get barkodDurumOzeti() {
    if (!this.sonDurumBilgisi) {
      return this.hareketOzetMetni(this.sonDurumKaydi);
    }

    const tarih = this.formatUyapTarih(this.sonDurumBilgisi.son_islem_tarihi);
    const saat = this.formatUyapSaat(this.sonDurumBilgisi.son_islem_saati);
    const konumSatiri = this.hareketKonumMetni(this.sonDurumKaydi);

    const aciklamalar = [
      this.sonDurumBilgisi.son_durum_aciklama?.trim(),
      this.sonDurumBilgisi.teslim_durum_aciklama?.trim(),
      this.sonDurumKaydi?.aciklama?.trim() && this.sonDurumKaydi?.aciklama?.trim() !== '-' ? this.sonDurumKaydi?.aciklama?.trim() : '',
      this.sonDurumKaydi?.islem_detay?.trim() && this.sonDurumKaydi?.islem_detay?.trim() !== '-' ? this.sonDurumKaydi?.islem_detay?.trim() : ''
    ].filter(Boolean);

    const zamanSatiri = [tarih, saat].filter(Boolean).join(' ');
    const detaySatiri = aciklamalar.join(' · ');

    return [zamanSatiri, detaySatiri, konumSatiri].filter(Boolean).join(' · ');
  }

  get sonDurumDetaylari() {
    const detaylar: Array<{ label: string; value: string }> = [];
    const kayit = this.sonDurumKaydi;
    const durum = this.sonDurumBilgisi;

    const tarih = this.formatUyapTarih(durum?.son_islem_tarihi) || kayit?.tarih?.trim() || '';
    const saat = this.formatUyapSaat(durum?.son_islem_saati) || kayit?.saat?.trim() || '';
    const zaman = [tarih, saat].filter(Boolean).join(' · ');
    if (zaman) {
      detaylar.push({label: 'Tarih/Saat', value: zaman});
    }

    const konum = this.hareketKonumMetni(kayit) || kayit?.il_ilce?.trim() || '';
    if (konum) {
      detaylar.push({label: 'Konum', value: konum});
    }

    const teslimAlan = durum?.teslim_alan?.trim();
    if (teslimAlan) {
      detaylar.push({label: 'Teslim Alan', value: teslimAlan});
    }

    const badgeMetni = durum?.son_durum_aciklama?.trim() || '';
    const aciklamaKaynaklari = [
      durum?.teslim_durum_aciklama,
      kayit?.islem_detay,
      kayit?.aciklama
    ];

    const aciklamalar = aciklamaKaynaklari
        .map((item) => item?.trim())
        .filter((item) => !!item && item !== '-' && item !== badgeMetni);

    if (aciklamalar.length > 0) {
      const benzersiz = Array.from(new Set(aciklamalar));
      detaylar.push({label: 'Açıklama', value: benzersiz.join(' · ')});
    }

    return detaylar;
  }

  get tebligatOzetBilgileri() {
    const items: Array<{ label: string; value: string }> = [];
    const sekilKey = this.localValue.tebligat_sekli as keyof typeof TebligatSekliLabel;
    const turKey = this.localValue.tebligat_turu as keyof typeof TebligatTuruLabel;
    const durumKey = this.localValue.tebligat_durumu as keyof typeof TebligatDurumuLabel;

    if (sekilKey) {
      items.push({label: 'Şekil', value: TebligatSekliLabel[sekilKey] || ''});
    }
    if (turKey) {
      items.push({label: 'Tür', value: TebligatTuruLabel[turKey] || ''});
    }
    if (durumKey) {
      items.push({label: 'Durum', value: TebligatDurumuLabel[durumKey] || ''});
    }

    if (this.localValue.tebligat_gonderim_tarihi) {
      const gonderim = this.$helper.tarihStr(this.localValue.tebligat_gonderim_tarihi);
      if (gonderim) {
        items.push({label: 'Gönderim', value: gonderim});
      }
    }

    return items.filter(item => !!item.value);
  }

  get barkodSonIslemAdim() {
    const durumAciklama = this.sonDurumBilgisi?.son_durum_aciklama?.trim();
    if (durumAciklama) {
      return durumAciklama;
    }

    return this.sonDurumKaydi?.islem || '—';
  }

  get sonDurumKaydi(): PttHareket | null {
    const hamVeri = this.barkodHamVeri?.hareketDongu;
    if (!hamVeri || hamVeri.length === 0) {
      return null;
    }

    if (!this.sonDurumBilgisi) {
      return this.enGuncelHareket(hamVeri);
    }

    const hedefTarih = this.normalizeUyapTarih(this.sonDurumBilgisi.son_islem_tarihi);
    const hedefSaat = this.normalizeUyapSaat(this.sonDurumBilgisi.son_islem_saati);

    const eslesen = hamVeri.find((hareket) => {
      const hareketTarih = this.normalizeUyapTarih(hareket.intTarih?.toString() || hareket.tarih);
      const hareketSaat = this.normalizeUyapSaat(hareket.intSaat?.toString() || hareket.saat);
      return (!hedefTarih || hareketTarih === hedefTarih) && (!hedefSaat || hareketSaat === hedefSaat);
    });

    return eslesen || this.enGuncelHareket(hamVeri);
  }

  formatUyapTarih(deger: string | null | undefined) {
    if (!deger) {
      return '';
    }
    const temiz = deger.toString().trim();
    const sayilar = temiz.replace(/[^0-9]/g, '');
    if (sayilar.length !== 8) {
      return '';
    }
    const yil = sayilar.substring(0, 4);
    const ay = sayilar.substring(4, 6);
    const gun = sayilar.substring(6, 8);
    return `${gun}/${ay}/${yil}`;
  }

  formatUyapSaat(deger: string | null | undefined) {
    if (!deger) {
      return '';
    }
    const temiz = deger.toString().trim();
    const sayilar = temiz.replace(/[^0-9]/g, '');
    if (sayilar.length < 4) {
      return '';
    }
    const saat = sayilar.substring(0, 2).padStart(2, '0');
    const dakika = sayilar.substring(2, 4).padStart(2, '0');
    const saniye = sayilar.length >= 6 ? sayilar.substring(4, 6).padStart(2, '0') : '';
    return [saat, dakika, saniye].filter(Boolean).join(':');
  }

  normalizeUyapTarih(deger: string | null | undefined) {
    if (!deger) {
      return '';
    }
    const sayilar = deger.toString().replace(/[^0-9]/g, '');
    return sayilar.padStart(8, '0');
  }

  normalizeUyapSaat(deger: string | null | undefined) {
    if (!deger) {
      return '';
    }
    const sayilar = deger.toString().replace(/[^0-9]/g, '');
    return sayilar.padStart(6, '0');
  }

  hareketKonumMetni(hareket: PttHareket | null | undefined) {
    if (!hareket) {
      return '';
    }
    const konum = [hareket.isyeri?.trim(), hareket.il?.trim(), hareket.ilce?.trim()].filter(Boolean);
    if (konum.length === 0) {
      return '';
    }
    if (konum.length === 1) {
      return konum[0];
    }
    const [isyeri, il, ilce] = konum;
    return [isyeri, [il, ilce].filter(Boolean).join('/')].filter(Boolean).join(' · ');
  }

  hareketOzetMetni(hareket: PttHareket | null | undefined) {
    if (!hareket) {
      return 'Hareket bilgisi bulunamadı';
    }
    const zaman = [hareket.tarih, hareket.saat].filter(Boolean).join(' ');
    const detay = [hareket.islem, hareket.sube, hareket.il_ilce].filter(Boolean).join(' · ');
    return [zaman, detay].filter(Boolean).join(' · ');
  }

  enGuncelHareket(hareketler: PttHareket[]): PttHareket {
    return hareketler.reduce((enGuncel, hareket) => {
      const mevcutTarih = this.normalizeUyapTarih(enGuncel.intTarih?.toString() || enGuncel.tarih);
      const mevcutSaat = this.normalizeUyapSaat(enGuncel.intSaat?.toString() || enGuncel.saat);
      const hareketTarih = this.normalizeUyapTarih(hareket.intTarih?.toString() || hareket.tarih);
      const hareketSaat = this.normalizeUyapSaat(hareket.intSaat?.toString() || hareket.saat);

      if (hareketTarih > mevcutTarih) {
        return hareket;
      }
      if (hareketTarih === mevcutTarih && hareketSaat > mevcutSaat) {
        return hareket;
      }
      return enGuncel;
    }, hareketler[0]);
  }

  toggleBarkodDetay() {
    this.showBarkodDetay = !this.showBarkodDetay;
  }

  mounted() {
    this.setDefaultValues();
    this.tebligTarihiniIzleyenGun;
  }

  load() {
    this.$emit("load");
  }

  onSuccess(tebligat: TebligatEntity) {
    this.formWrapper.onFly = true;
    this.localValue.adres = this.adres.varsayilan_adres
    if (!tebligat.adres?.id) {
      if (this.localValue.itirazin_iptali_davasi?.[0]) {
        this.$http.post('/api/v1/tebligat/' + tebligat.id + '/itirazin-iptali-davasi', this.localValue.itirazin_iptali_davasi[0]);
      }
      this.saveAdres(tebligat.id, this.localValue.adres);
    } else {
      if (this.localValue.itirazin_iptali_davasi?.[0]?.id) {
        this.$http.put('/api/v1/tebligat/' + tebligat.id + '/itirazin-iptali-davasi/', this.localValue.itirazin_iptali_davasi[0]).finally(() => (this.formWrapper.onFly = false));
      } else if (this.localValue.itirazin_iptali_davasi?.[0]) {
        this.$http.post('/api/v1/tebligat/' + tebligat.id + '/itirazin-iptali-davasi', this.localValue.itirazin_iptali_davasi[0]).finally(() => (this.formWrapper.onFly = false));
      }
      this.$emit("onSuccess", tebligat);
    }
    this.load()
  }

  saveAdres(tebligatId: number, adres: AdresEntity) {
    this.$http.post("/api/v1/tebligat/" + tebligatId + "/adres", adres).then(() => {
      this.$emit("onSuccess");
    }).finally(() => (this.formWrapper.onFly = false));
  }
}
